export default __webpack_public_path__ + "d97df12839afecc795a5405cb09b4717.png";